import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import { Search } from '@mui/icons-material';
export default function Header() {
    return (

 <div className="container-fluid topbar bg-light py-3 d-none d-lg-block px-0">
  <div className="container px-0"> {/* remove padding here */}
    <div className="row gx-0 align-items-center justify-content-between">
      {/* Logo */}
      <div className="col-lg-2 text-center text-lg-start mb-lg-0">
        <a href="https://www.alsagrins.ae/" className="d-inline-flex align-items-center" target="_blank" rel="noopener noreferrer">
          <img src="img/comp_logo.png" alt="Logo" className="img-fluid" style={{ height: '70px' }} />
        </a>
      </div>
  
 <div className="col-lg-3 text-end">
  <a
    href="https://micustomer.alsagrins.ae/complaintsandfeedback"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-outline-custom btn-sm px-4"
  >
    Complaint / Feedback
  </a>
</div>
        {/* <Button variant="contained" color="primary" type="submit">
          Complaint/Feedback
        </Button> */}
      
    </div>
  </div>
</div>


    )


}